import { useMutation, useQueryClient } from '@tanstack/react-query'

import { apiPostGachaDraw } from '@/apis/gacha/postGachaDraw'

import { COIN_KEYS } from '../keys/coins'
import { GACHA_KEYS } from '../keys/gacha'

export const usePostGachaDraw = (gachaEventId: number) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: () => apiPostGachaDraw(gachaEventId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [COIN_KEYS.BALANCE] })
      queryClient.invalidateQueries({ queryKey: [GACHA_KEYS.PITY_GAUGE, gachaEventId] })
      queryClient.invalidateQueries({ queryKey: [GACHA_KEYS.RECENT_WINNERS, gachaEventId] })
    },
  })
}
